import { push } from 'connected-react-router';

export default () => (dispatch) => dispatch(push(`/templates`));
